export const getUserSalesTargetStaticstics = {
  GET_USER_SALES_TARGET_STATICSTICS_REQUEST: "GET_USER_SALES_TARGET_STATICSTICS_REQUEST",
  GET_USER_SALES_TARGET_STATICSTICS_SUCCESS: "GET_USER_SALES_TARGET_STATICSTICS_SUCCESS",
  GET_USER_SALES_TARGET_STATICSTICS_ERROR: "GET_USER_SALES_TARGET_STATICSTICS_ERROR",
};
